import { Component, Input } from '@angular/core';
import { StatusService } from '@core/services/status.service';
import { PayeeOverride, ProcessingTypes } from '@core/typings/payment.typing';
import { PaymentStatus, PaymentSubStatus } from '@core/typings/status.typing';

@Component({
    selector: 'gc-payment-status-block',
    templateUrl: './payment-status-block.component.html',
    styleUrls: ['./payment-status-block.component.scss'],
    standalone: false
})
export class PaymentStatusBlockComponent {
  @Input() status: string;
  @Input() subStatus: PaymentSubStatus;
  @Input() statusId: PaymentStatus;
  @Input() isArchived: boolean;
  @Input() statusDate: string;
  @Input() isForApplicantPortal: boolean;
  @Input() processor: ProcessingTypes;
  @Input() payeeOverride: PayeeOverride;
  @Input() hidePaymentStatus: boolean;
  @Input() alternatePaymentStatusText: string;

  ProcessingTypes = ProcessingTypes;
  paymentSubStatusMap = this.statusService.paymentSubStatusMap;
  paymentStatusMap = this.statusService.paymentStatusMap;

  constructor (
    private statusService: StatusService
  ) { }
}
